// Registers a redux-form field (so its initial value is submitted) without rendering any DOM.
const HiddenField = () => null

export default HiddenField
